module.exports = __webpack_public_path__ + "img/Bitmap@231x (1).ac931162.png";